import { trpc } from "../trpc";

interface Input {
  folderId: string;
}

export function useSetFolderNotes({ folderId }: Input) {
  const utils = trpc.useUtils();

  const mutation = trpc.folder.updateFolderNotes.useMutation({
    onMutate: async ({ notes }) => {
      await utils.folder.getById.cancel({ folderId });

      // Store previous data for rollback.
      const previousData = utils.folder.getById.getData({ folderId });

      utils.folder.getById.setData({ folderId }, (previousFolder) => {
        if (!previousFolder) {
          return previousFolder;
        }
        return { ...previousFolder, notes };
      });

      return { previousData };
    },
    onError: (_error, _variables, context) => {
      if (context?.previousData) {
        utils.folder.getById.setData({ folderId }, context.previousData);
      }
    },
    onSettled: async () => {
      await utils.folder.getById.invalidate({ folderId });
    },
  });

  return {
    setFolderNotesAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
}
